import {
  makeRequest,
  constructUrlParams,
  formatDateParam,
} from "../lib/makeRequest";

export const branch_category_overall = (data) => {
  const params = {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  };
  return makeRequest("/branch-categories/overall", params);
};

export const branch_category_cluster = (data) => {
  const params = {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  };
  return makeRequest(`/branch-categories/cluster/${data.clusterId}`, params);
};

export const branch_category_area = (data) => {
  const params = {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  };
  return makeRequest(`/branch-categories/area/${data.areaId}`, params);
};

export const branch_category_branch = (data) => {
  const urlParams = constructUrlParams(data);
  return makeRequest(
    `/branch-categories/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
